import { Component, OnDestroy, OnInit } from "@angular/core";
import { LayoutService } from "@core/services/common";
import { Footer } from "@layouts/components/footer/footer";
import { Sidenav } from "@layouts/components/sidenav/sidenav";
import { Topbar } from "@layouts/components/topbar/topbar";
import { debounceTime, fromEvent, Subscription } from "rxjs";

@Component({
  selector: "app-vertical-layout",
  imports: [Sidenav, Topbar, Footer],
  template: `
    <div class="wrapper">
      <app-sidenav />

      <app-topbar />

      <div class="content-page">
        <ng-content />

        <app-footer />
      </div>
    </div>
  `,
})
export class VerticalLayout implements OnInit, OnDestroy {
  constructor(public layout: LayoutService) {}

  resizeSubscription!: Subscription;
  private defaultSidenavSize!: string;

  ngOnInit() {
    // Prefer full sidebar; ignore stuck condensed from session
    const size = this.layout.sidenavSize
    this.defaultSidenavSize =
      size === "condensed" || size === "offcanvas" ? "default" : size

    if (window.innerWidth > 768) {
      this.layout.updateLayout({ sidenavSize: this.defaultSidenavSize })
    }

    this.onResize()

    this.resizeSubscription = fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => this.onResize())
  }

  onResize(): void {
    const width = window.innerWidth
    // Mobile only: use offcanvas. Keep full sidebar on tablet/desktop (like default UI).
    if (width <= 768) {
      this.layout.updateLayout({ sidenavSize: "offcanvas" })
      return
    }
    if (this.layout.sidenavSize === "offcanvas") {
      this.layout.updateLayout({
        sidenavSize: this.defaultSidenavSize || "default",
      })
    }
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
  }
}
